function syncHeights() {
    const large = document.querySelector('.js-product-thumbnail');
    const small = document.querySelector('.js-product-second_image');

    if (!small || !large) return;

    if(document.documentElement.clientWidth < 768) return;

    const smallHeight = small.offsetHeight;
    large.style.maxHeight = smallHeight + 'px';
}

// au chargement
window.addEventListener('load', syncHeights);
